import React from 'react'

export default {
  faqs: [
    {
      question:
        'How do I become a VIP? / Does it cost anything to become a VIP?',
      answer:
        "It's simple — and FREE! All you need is a Priceline account to become a member and 2 completed trips to become a VIP. Every completed trip gets you closer to the next VIP tier and even more benefits. Have you booked with Priceline in the past? You may instantly qualify for a higher VIP level!"
    },
    {
      question: 'When will my VIP status change?',
      answer:
        "You'll see your VIP status change 24 hours after your trip is complete."
    },
    {
      question: 'How can I fast-track my status?',
      answer: (
        <ol>
          <li>
            Each reservation within a Package booking counts separately toward
            your VIP progress and helps you gain VIP status more quickly. Bundle
            your products to save even more and accelerate your VIP progress.
          </li>
          <br />
          <li>
            Priceline Rewards™ Visa® Card cardholders automatically become VIP
            gold members upon account approval. Apply now at{' '}
            <a href="https://www.pricelinevisa.com">www.pricelinevisa.com</a> to
            start enjoying the benefits of VIP.
          </li>
        </ol>
      )
    },
    {
      question: 'Does my VIP status expire?',
      answer:
        'As long as you keep booking trips on Priceline, your status will not expire.'
    },
    {
      question: 'Do trips from last year count towards my current VIP status?',
      answer: (
        <>
          All complete trips that were booked after May 31st, 2019 will count
          towards your VIP status through December 30th, 2020. <br /> <br />
          Your VIP status on January 1st, 2021 will be determined by the number
          of completed trips from either 2019 OR 2020 (whichever year contains
          the highest number of trips). <br /> <br />
          You can upgrade your status within 2021 based on your number of
          completed trips starting January 1st, 2021.
        </>
      )
    },
    {
      question: "What if I've booked using more than one email address?",
      answer:
        "We aren't able to merge trips from different email addresses at this time, so be sure to always book with the email associated with your profile."
    },
    {
      question: 'What happens to my status if I cancel a booking?',
      answer:
        'We get it — plans change. Any cancelled bookings will not be counted towards your VIP progress.'
    },
    {
      question:
        'Can my friends and family members take advantage of my VIP benefits?',
      answer:
        'At this time, your VIP benefits cannot be shared with multiple users and are reserved for your usage only.'
    },
    {
      question: 'Can I change or cancel my reservation if I become a VIP?',
      answer:
        'The ability to cancel depends on the type of booking and the cancellation policy associated with your reservation. Only trips that are completed count towards your VIP status.'
    },
    {
      question:
        "What happens if I book without signing in or if I don't have an account? Do those trips still count towards my VIP status?",
      answer:
        "Don't fret! Any bookings made under the same email address will count towards your VIP status even you aren't signed in. If you don't have an account yet, previous bookings made with the email address you use to create the account will automatically be counted toward your VIP status."
    },
    {
      question: 'How can I tell which products qualify for VIP discounts?',
      answer:
        "It's easy — just look for the Priceline VIP logo in your search results."
    },
    {
      question: 'Are the VIP benefits transferable?',
      answer: 'Not at this time.'
    },
    {
      question:
        'Do I need to spend a certain amount in order to have a booking count towards my VIP status?',
      answer:
        'Nope! There are no minimum spend requirements. Your VIP status is based only on the number of completed trips associated with your account.'
    },
    {
      question:
        'I have the Priceline Rewards™ Visa® Card but I’m not a VIP Gold member?',
      answer:
        'To be recognized as a VIP GOLD member, your card details in your Priceline profile need to be up to date. Sign in to your Priceline profile, select “My Profile” and update your payment information with your Priceline Rewards™ Visa® Card. Be sure to check that your 16-digit card number is correct and that the expiration date is current. Once your card details are updated, please allow 24-48 hours for your VIP status to be updated to Gold.'
    },
    {
      question:
        'My Priceline Rewards™ Visa® Card is loaded into my Priceline profile, and I’m still not being recognized as a GOLD VIP member?',
      answer:
        'Be sure to check that your 16-digit card number is correct and that the expiration date is current. Once your card details are updated, please allow 24-48 hours for your VIP status to be updated to Gold.'
    },
    {
      question:
        'I don’t have my Priceline Rewards™ Visa® Card information and/or my card has expired?',
      answer: (
        <>
          Please{' '}
          <a href="https://www.barclaycardus.com/servicing/headerLinks?handleContactUs=">
            contact Barclay’s
          </a>{' '}
          to obtain your card information and/or to order a replacement card. If
          you are not a current cardmember, you may apply for a new card by
          visiting{' '}
          <a href="https://www.pricelinevisa.com">www.pricelinevisa.com</a>.
        </>
      )
    },
    {
      question:
        'My Priceline Rewards™ Visa® Card details are up to date with the expiration date, and it’s still not registering Gold?',
      answer:
        'Please contact Priceline Customer Care through chat or SMS text to 33296.'
    },
    {
      question:
        'I just signed up for the Priceline Rewards™ Visa® Card. When will I be considered a VIP Gold member?',
      answer:
        'Please allow 24-48 hours for your VIP status to be updated to Gold.'
    }
  ],
  valueProp: {
    contents: [
      {
        id: 1,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/couple-friends-excited-airport-terminal.jpg?opto&width=256&crop=1:1,smart',
        imageAlt: 'Hilarious smiling couple playing at terminal',
        headLine: `Become a member for FREE!\nNo strings attached.`
      },
      {
        id: 2,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/getaways-waterfront-mountain-cottage.jpg?opto&width=256&crop=1:1,smart',
        imageAlt:
          'Beautiful house on a hill overlooking water. Inspirational place to stay on vacations',
        headLine: 'Always get our Best Price.\nGuaranteed.'
      },
      {
        id: 3,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-smiling-group-selfie.jpg?opto&width=256&crop=1:1,smart',
        imageAlt:
          'Happy friends from diverse cultures and races taking selfie with back lighting - Youth and friendship concept with young people having fun together',
        headLine: 'Unlock exclusive VIP discounts and coupons.'
      }
    ]
  },
  zigzag: {
    content: [
      {
        id: 1,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-cheering-mountain-top.jpg?opto&width=600&crop=1:1,smart',
        imageAlt:
          'Big group of people having fun in success pose with raised arms on mountain top against sunset lakes and mountains. Travel, adventure or expedition concept',
        iconName: 'verified',
        iconText: 'Best Price.\nGuaranteed.',
        headLine: 'Your short-cut to\nsavings.',
        subHeadLine:
          "You'll automatically get our best price guarantee so you can spend less time searching for deals and more time traveling.",
        button: 'Sign Up'
      },
      {
        id: 2,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/friends-underwater-pool-selfie.jpg?opto&width=600&crop=1:1,smart',
        imageAlt: 'Young couple smiling under water',
        iconName: 'hotels',
        iconText: 'Travel like\na VIP',
        headLine: 'Get the service you\ndeserve.',
        subHeadLine:
          "From early access to sales to priority customer service, you'll always be our top priority.",
        button: 'Get Started'
      },
      {
        id: 3,
        imageSrc:
          'https://s1.pclncdn.com/design-assets/vip/roadtrip-shoes-car-dashboard.jpg?opto&width=600&crop=1:1,smart',
        imageAlt:
          'Female legs in ripped jeans and blue sneakers inside car with mountains landscape at background. Woman relaxing during road trip',
        iconName: 'cars',
        iconText: 'Hotel and Rental\nCar Discounts',
        headLine: 'Travel large, spend small. Save big on every trip you take.',
        subHeadLine:
          'Get even better deals on thousands of hotels and rental cars!',
        button: 'Start Saving!'
      }
    ]
  },
  quotes: [
    {
      quote:
        'We can always depend on Priceline for the best rates. We, being VIP members, are always given a discount.',
      customer: {
        name: 'Mrs. Z'
      }
    },
    {
      quote:
        "I've used Priceline ever since I became a frequent traveler. I am now VIP and love all of the deals I get on rooms, flights, cars! You name it!",
      customer: {
        name: 'Jason D'
      }
    },
    {
      quote:
        "I love using Priceline!! I get great discounts and I'm already VIP and I'm fairly new.",
      customer: {
        name: 'Eli W'
      }
    }
  ]
}
